// THE Signal palette (DWLF-298) — the single source for both colour schemes. theme.js builds the MUI
// palettes from it and tokenCss (injected by <GlobalStyles> in index.js) turns it into the var(--dwlf-*)
// tokens the app styles with, so a colour changes in exactly one place. Values come from the design
// canvas boards TDesk-signal / TDesk-signal-light.

export const SCHEMES = {
  dark: {
    bg: '#0a0a0c', sunk: '#0d0d10', surface: '#111114', elevated: '#18181c', text: '#ffffff',
    accent: '#00e5ff', 'accent-hi': '#6effff', 'accent-lo': '#00b2cc', 'on-accent': '#0a0a0c',
    warn: '#ffb800', up: '#00ff88', down: '#ff3b3b',
    // Secondary-text alphas (0.4+) are multiplied by this so they keep contrast on a light ground.
    boost: 1,
  },
  light: {
    bg: '#f4f5f6', sunk: '#eceef0', surface: '#ffffff', elevated: '#e6e8eb', text: '#0a0a0c',
    accent: '#00718f', 'accent-hi': '#005a72', 'accent-lo': '#0a8fb3', 'on-accent': '#ffffff',
    warn: '#9a5c00', up: '#00794b', down: '#c42626',
    boost: 1.3,
  },
};

// Alpha ladders: var(--dwlf-<channel>-NN), e.g. --dwlf-ink-50 is the text colour at 50%.
const CHANNELS = { ink: 'text', accent: 'accent', warn: 'warn', up: 'up', down: 'down', bg: 'bg' };
const STEPS = [2, 3, 4, 5, 6, 8, 10, 12, 15, 16, 20, 25, 30, 35, 40, 45, 50, 55, 60, 62, 65, 70, 75, 80, 82, 85, 88, 90, 95];

const rgb = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16)).join(' ');

const schemeBlock = (name, s) => {
  const lines = Object.entries(s)
    .filter(([k]) => k !== 'boost')
    .map(([k, v]) => `--dwlf-${k}: ${v};`);
  lines.push(`--dwlf-boost: ${s.boost};`);
  Object.entries(CHANNELS).forEach(([c, src]) => lines.push(`--dwlf-${c}-rgb: ${rgb(s[src])};`));
  return `color-scheme: ${name}; ${lines.join(' ')}`;
};

const ladder = () => Object.keys(CHANNELS)
  .flatMap((c) => STEPS.map((a) => {
    const alpha = c === 'ink' && a >= 40 ? `calc(${a / 100} * var(--dwlf-boost))` : String(a / 100);
    return `--dwlf-${c}-${String(a).padStart(2, '0')}: rgb(var(--dwlf-${c}-rgb) / ${alpha});`;
  }))
  .join(' ');

// The scheme is chosen by <html data-dwlf-theme="dark|light">, set by MUI's colour-scheme manager and,
// before first paint, by the inline script in public/index.html. Dark is the default without it.
export const tokenCss = [
  `:root, [data-dwlf-theme="dark"] { ${schemeBlock('dark', SCHEMES.dark)} }`,
  `[data-dwlf-theme="light"] { ${schemeBlock('light', SCHEMES.light)} }`,
  `:root { ${ladder()} }`,
].join('\n');
